import React from 'react';
import { Navbar, Nav, NavItem, NavLink } from 'reactstrap';
import ReactGA from 'react-ga';
import liaison_logo from './assets/liaison_logo.png';

class Footer extends React.Component {
    render(){
        return (
            <footer className="main-footer">
                <Navbar color="faded" toggleable className="justify-content-start">
                    <Nav navbar>
                        <NavItem>
                            <ReactGA.OutboundLink
                                eventLabel="terms-of-use"
                                to="http://www.commonapp.org/terms-of-use"
                                target="_blank"
                                className="nav-link"
                                rel="noopener noreferrer"
                            >
                                Terms of Use
                            </ReactGA.OutboundLink>
                        </NavItem>
                        <NavItem>
                            <ReactGA.OutboundLink
                                eventLabel="license-agreement"
                                to="http://www.commonapp.org/license-agreement"
                                target="_blank"
                                className="nav-link"
                                rel="noopener noreferrer"
                            >
                                License Agreement
                            </ReactGA.OutboundLink>
                        </NavItem>
                        <NavItem>
                            <ReactGA.OutboundLink
                                eventLabel="privacy-policy"
                                to="http://www.commonapp.org/privacy-policy"
                                target="_blank"
                                className="nav-link"
                                rel="noopener noreferrer"
                            >
                                Privacy Policy
                            </ReactGA.OutboundLink>
                        </NavItem>
                        <NavItem>
                            <ReactGA.OutboundLink
                                eventLabel="support"
                                to="https://membersupport.commonapp.org/membersupport/s/contactsupport"
                                target="_blank"
                                className="nav-link"
                                rel="noopener noreferrer"
                            >
                                Need help?
                            </ReactGA.OutboundLink>
                        </NavItem>
                    </Nav>
                    <Nav navbar className="ml-auto">
                        <NavItem>
                            <NavLink>
                                In Partnership with
                                <img src={liaison_logo} alt="Liaison International" className="liaison-logo" />
                            </NavLink>
                        </NavItem>
                    </Nav>
                </Navbar>
            </footer>
        );
    }
}

export default Footer;




// WEBPACK FOOTER //
// ./src/components/partials/Footer.jsx